import getIsInCheckedMode from 'mini-mail-list-store/lib/utils/getIsInCheckedMode';
import isInLandscapeMode from 'dom-utils/lib/utils/isInLandscapeMode';
import { getModuleSwitcherHeight } from '../../utils/mailList/moduleSwitcherHeight';
import { isInSearchView } from 'mini-mail-list-store/lib/selectors/isInSearchView';
import { isIOS } from 'mini-device-utils/lib/utils/isIOS';
import { isUnifiedSearchView } from 'mini-mail-list-store/lib/selectors/isUnifiedSearchView';
import type { WindowDimensions } from 'mini-hooks/lib/useWindowDimensions';
import {
    HEADER_HEIGHT,
    UNIFIED_SEARCH_HEADER_HEIGHT,
} from '../../utils/mailList/getListItemHeight';

/**
 * This function calculates the height of the virtualize container.
 */
export const getMailListContainerHeight = (windowDimensions: WindowDimensions): number => {
    const windowInnerHeight = windowDimensions.height;
    const isUnifiedSearch = isUnifiedSearchView();
    const isInCheckedMode = getIsInCheckedMode();

    // In MultiSelect mode, only the MultiSelectHeader is shown in UnifiedSearch
    const listHeaderHeight =
        isUnifiedSearch && !isInCheckedMode ? UNIFIED_SEARCH_HEADER_HEIGHT : HEADER_HEIGHT;

    let footerHeight = 0;

    if (getIsInCheckedMode()) {
        footerHeight = getModuleSwitcherHeight();
    } else if (isInSearchView() || isInLandscapeMode() || isUnifiedSearch) {
        // In Landscape mode, ModuleSwitcher is moved to the left but
        // MultiSelectFooter remains at bottom only.
        footerHeight = 0;
    } else {
        footerHeight = getModuleSwitcherHeight();
    }

    const isFooterPresent: boolean = !!footerHeight;

    // For iphone X and above, we apply safe area padding to avoid overlap of our app footer with the iphone home button.
    if (isIOS() && isFooterPresent) {
        const safeAreaInsetBottomHeight =
            parseFloat(getComputedStyle(document.documentElement)?.getPropertyValue('--sab')) || 0;
        footerHeight += safeAreaInsetBottomHeight;
    }
    return windowInnerHeight - listHeaderHeight - footerHeight;
};
